import type { Unit } from '@unit/shared';

/**
 * The places a soldier can sit, for a picker: every active platoon itself
 * ("directly on the platoon" — a soldier need not belong to a team, owner
 * 2026-09-13, story 32) followed by its active teams, in org order.
 */
export interface UnitOption {
  id: string;
  type: Unit['type'];
  label: string;
}

export function unitOptions(units: readonly Unit[], directLabel: (platoon: string) => string): UnitOption[] {
  const platoons = units.filter((u) => u.type === 'platoon' && u.active).sort((a, b) => a.order - b.order);
  return platoons.flatMap((p) => [
    { id: p.id, type: 'platoon' as const, label: directLabel(p.name) },
    ...units
      .filter((u) => u.type === 'team' && u.active && u.parentId === p.id)
      .sort((a, b) => a.order - b.order)
      .map((t) => ({ id: t.id, type: 'team' as const, label: `${p.name} · ${t.name}` })),
  ]);
}
